import React from 'react';

import { Group, Skeleton, Text } from '@mantine/core';

interface ISummaryStatsProps {
  completed?: number;
  almostDone?: number;
  total?: number;
  isLoading: boolean;
}

const SummaryStats = ({ completed, almostDone, total, isLoading }: ISummaryStatsProps): JSX.Element => {
  if (isLoading) return <Skeleton height={20} width={260} />;

  return (
    <Group spacing='lg' noWrap>
      <Text size='sm'>
        <Text span weight={600}>
          {completed ?? 0}
        </Text>{' '}
        completed
      </Text>
      <Text size='sm'>
        <Text span weight={600}>
          {almostDone ?? 0}
        </Text>{' '}
        almost done
      </Text>
      <Text size='sm' color='dimmed'>
        {total ?? 0} showing
      </Text>
    </Group>
  );
};

export default SummaryStats;
